module.exports = __webpack_public_path__ + "img/blackshepherdsfinal_wuppertal.9caa84f2.jpg";